import { REFUND_APPROVAL_TEXT } from '../../constants/refundApprovalText'

export const getRefundConfirmApproveLabel = (compact = false) =>
  compact ? REFUND_APPROVAL_TEXT.confirmApproveShort : REFUND_APPROVAL_TEXT.confirmApprove
